import { createCompassModalSwitcher } from "@circle-react/components/SettingsApp/CompassCompat/createCompassModalSwitcher";

import { AgentProfileModalComponent } from "./AgentProfileModalComponent";
import { AgentProfileModalUIKitComponent } from "./AgentProfileModalUIKitComponent";

export const useAgentProfileModal = createCompassModalSwitcher(
  AgentProfileModalComponent,
  AgentProfileModalUIKitComponent,
);
